import { MaterialUICore } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const Container = styled('div')({
  position: 'relative',
});
